import {authenticationStatus, baseUrl, cookieName} from "../store/stores";
import {Cookie} from "./Cookie";

let cookieName_value:string;
cookieName.subscribe(value => {
    cookieName_value = value;
});

const authentication = async () => {
    let auth: boolean = false;
    let baseUrl_value;

    const cookie = new Cookie();
    let token = cookie.getCookie(cookieName_value);

    if (typeof token === 'string') {

        baseUrl.subscribe(value => {
            baseUrl_value = value;
        });

        try{
            const rawResponse = await fetch(baseUrl_value + 'check_token', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
            const content = await rawResponse.json();

            if (content.success) {

                let authStatus = {authenticated: content.success}
                authenticationStatus.set(authStatus)

                auth = true;
                return auth;
            }
            else {

                //We delete the cookie
                document.cookie = cookieName_value + '=deleted; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';

                //We put the property authenticated at false
                let authStatus = {authenticated: false}
                authenticationStatus.set(authStatus)

                return auth;
            }
        }
        catch (e){
            return auth;
        }
    }
    else {
        return auth;
    }
};

const notLoggedInCheck = () => {

    const cookie = new Cookie();
    let token = cookie.getCookie(cookieName_value);

    // If it's not a boolean return, the user has a token.
    // So he doesn't need to stop at the login page
    return typeof token === 'boolean';
};

export {authentication, notLoggedInCheck};